import React from 'react'
import styled from 'styled-components'

const ProjectCard = ({item,isFromHobby}) => {

    const TectItem = ({item})=>{
        return(
            <div>
                <p className='tech-item'>{item}</p>

            </div>
        )
    }

  return (
    <Wrapper>
    <div className={isFromHobby ? 'project-container-hobby'  : 'project-container'}>
        <div className='left-container'>
            <img className={isFromHobby ? 'image-hobby' : 'image'} src={item.img} />
        </div>
        <div className='right-container'>
            <h1 className='project-name'>{item.projectName}</h1>
            <p>{item.description}</p>
            <p className='tech-heading'>USED STACK</p>
            <div className='tech-array-container'>
            {item.tech.map((item)=> <TectItem item={item}/>)}
            </div>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
      View Project
    </a>
          
        </div>
    </div>

    </Wrapper>

  )
}

const Wrapper = styled.section`
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    border-radius: 1rem;
    margin: 2rem 0;
    /* background-color: red; */
    padding: 1rem;
    p{
        word-wrap: break-word
    }
    a{
        text-decoration:none;
        color: #D40B7E;
        font-weight: bold;
        font-size: small;
    }

.image{
    /* max-height: 200px; */
    max-width: 200px;
    border-radius: 0.5rem;
}
.image-hobby{
    border-radius: 0.5rem;
    max-width: 400px;
}
.project-container{
    width: 100%;
    display: grid;
    grid-template-columns: 200px auto;

}
.project-container-hobby{
    width: 100%;
    display: grid;
    grid-template-columns: 400px auto;
}
.left-container{
    /* height: 5rem; */
}
.right-container{
    padding: 1rem;
}
.project-name{
    font-size: larger;
    color: gray;
    margin-top: 0;
}
.tech-array-container{
    display: flex;
    /* overflow: hidden; */
}
.tech-item{
    padding: 0.5rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    border: 1px solid #D40B7E;
    margin-right: 0.4rem;
    border-radius: 0.3rem;
    font-size: small;
}
.tech-heading{
    font-size: small;
    color: gray;
    margin: 0;
    margin-bottom: 0.4rem;

}
@media (max-width: 500px) {
    .project-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .project-container-hobby {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .tech-array-container{
        display: grid;
        grid-template-columns: repeat(3,1fr);
    }
    .tech-item{
        font-size: x-small;
        padding: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
  }
`

export default ProjectCard